var map = {
	"./ccavenue-live.png": 718,
	"./ccavenue-sandbox.png": 3639,
	"./cod-live.png": 3624,
	"./cod-sandbox.png": 721,
	"./paypal-live.png": 3605,
	"./paypal-sandbox.png": 3414,
	"./paytm-live.png": 7131,
	"./paytm-sandbox.png": 5252,
	"./razorpay-live.png": 1420,
	"./razorpay-sandbox.png": 5037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3274;